<template>
    <div v-show="showMenu" @mouseover="toggleMenu(true)" @mouseout="toggleMenu(false)" class="menuShowArea" :style="`width: showMenu ? '180px' : '0px'; height: showMenu ? 'calc(80% + 45px)' : '0px';`">
        <div class="nav-top">
            <div
                id="mini"
                class="fa fa-align-justify"
                style="font-weight: normal; font-size: 16px"
            >
                <i class="el-icon-menu i-menu"></i>
            </div>

            <div :class="[this.open ? 'navl' : 'navl nav-mini']">
                <el-scrollbar style="height: 100%; width: 100%">
                    <ul>
                        <li
                            class="nav-item"
                            :style="{backgroundColor: item.menu_id == currentMenuId ? '#021823' : ''}"
                            :key="index"
                            v-for="(item, index) in menuList"
                            @click.prevent="toggleSubMenu(index, item)"
                        >
                            <a href="javascript:;">
                                <span :style="{color: item.menu_id == currentMenuId ? '#56fbff' : ''}">
                                    <i :class="['iconfont', item.icon]"></i>
                                    {{ item.menu_name }}
                                </span>
                                <i
                                    v-if="item.childlist && !item.isOpen"
                                    class="el-icon-arrow-right icon-right"
                                ></i>
                                <i
                                    v-if="item.childlist && item.isOpen"
                                    class="el-icon-arrow-down icon-right"
                                ></i>
                            </a>
                            <!-- :class="[
                                index === currentIndex
                                    ? 'nav-open-sub'
                                    : 'nav-close-sub',
                            ]"-->
                            <ul
                                :class="[
                                    item.isOpen
                                        ? 'nav-open-sub'
                                        : 'nav-close-sub'
                                ]"
                            >
                                <li
                                    :key="cindex"
                                    v-for="(child, cindex) in item.childlist"
                                    @click.stop="routerGo(child)"
                                    :style="{backgroundColor: child.menu_id == currentMenuId ? '#021823' : ''}"
                                >
                                    <a href="javascript:;">
                                        <span :style="{color: child.menu_id == currentMenuId ? '#56fbff' : ''}">{{ child.menu_name }}</span>
                                    </a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </el-scrollbar>
            </div>
        </div>
    </div>
</template>
<script>
import Bus from '@/utils/eventBus.js';
export default {
    name: "Menu",
    components: {},
    data() {
        return {
            currentIndex: -1,
            open: false,
            oldMenuIndex: -1,
            currentMenuId: null,
        };
    },
    props: {
        // menuList: Array,
        showMenu: Boolean,
        openMenu: Boolean
    },
    computed: {
        menuList() {
            if (
                this.$route.meta.noMenu ||
                !this.$store.getters.isOpenMenuList.length
            ) {
                this.showMenu = false;
                this.$emit("update:showMenu", this.showMenu);
            } else {
                this.showMenu = true;
                this.$emit("update:showMenu", this.showMenu);
            }
            return this.$store.getters.isOpenMenuList;
        }
    },
    watch: {
        currentIndex(newVal, old) {
            this.oldMenuIndex = newVal;
        },
        openMenu(newVal) {
            if (newVal) {
                this.open = newVal;
            }
        }
    },
    methods: {
        toggleMenu(openFlag) {
            if (!openFlag) {
                this.openMenu = false;
                this.$emit("update:openMenu", this.openMenu);
            }
            this.open = openFlag;
        },
        /// 一级菜单点击事件
        toggleSubMenu(index, item) {
            this.$set(item, "isOpen", !item.isOpen);
            this.toggleMenu(false);
            this.toggleMenu(true);
            if (!item.childlist && item.route_path) {
                if (item.route_path == "/video-monitor") {
                    window.open("/video-monitor", "_blank");
                } else {
                    this.currentMenuId = item.menu_id;
                    this.$emit("changeTitle", item);
                    sessionStorage.setItem("activeTab", item.route_path);
                    this.$router.push(item.route_path);
                }
            }
        },
        changeMenuStatus(path) {
            if (path === "/ops-management" || path === "/energy-analysis")
                this.showMenu = true;
        },
        /**
         * @description: 二级菜单点击事件
         */
        routerGo(router) {
            this.currentMenuId = router.menu_id;
            this.$emit("changeTitle", router);
            sessionStorage.setItem("activeTab", router.route_path);
            if (router.route_path) {
                if (router.route_path == "/video-monitor") {
                    // window.open(
                    //     "http://172.17.22.111/dispatch.asp?user=admin&pass=china-xd&page=preview.asp[&slice=4&open={1,2,3,4,5,6,7,8,9,10,11,12,13,14,15}]",
                    //     "_blank"
                    // );
                } else if (router.route_path == "/sign_out") {
                    // 光伏监控跳转
                    window.open(
                        "https://saas.gw-greenenergy.com/saas/#/saas/photovoltaic/PVMonitor",
                        "_blank"
                    );
                } else {
                    this.$router.push(router.route_path);
                }
                // this.open = false;
                // this.showMenu = false;
            }
        }
    },
    created() {
        Bus.$on('currentMenuId', (message) => {
            this.currentMenuId = message;
        });
        // this.changeMenuStatus(this.$route.path);
    }
};
</script>
<style lang="scss">
/* nav background: #02195a url(../../../assets/image/index/youyou.png) top right no-repeat;*/
.menuShowArea {
    z-index: 9; 
    position: fixed; 
    bottom: 0; 
    .nav-top {
        bottom: 0;
        left: 0;
        line-height: 45px;
        color: #fff;
        position: fixed;
        // z-index: 99999999;
        color: #fff;
        // background: #2450c9;
        text-align: center;
        display: block;
        width: 180px;
        line-height: 45px;
        .i-menu {
            display: block;
            line-height: 45px;
            font-size: 23px;
        }
        .navl {
            width: 180px;
            height: 80%;
            padding-top: 30px;
            transition: all 0.3s;
            position: fixed;
            left: 0;
            bottom: 45px;
            z-index: 999999;
            overflow: hidden;
            /* offset-x | offset-y | color */
            // background: #02195a url(../../../../assets/image/index/youyou.png) top
            //     right no-repeat;
            .el-scrollbar__wrap {
                overflow-x: hidden !important;
                padding-bottom: 0 !important;
            }
            .nav-icon {
                font-size: 20px;
                position: absolute;
                margin-left: -1px;
            }
            a {
                display: block;
                overflow: hidden;
                // padding-left: 20px;
                padding-left: 14px;
                line-height: 46px;
                max-height: 46px;
                color: #abb1b7;
                transition: all 0.3s;
                font-size: 14px;
                &:focus {
                    outline: none;
                }
                i {
                    line-height: 46px;
                    font-size: 14px;
                    // padding-right: 20px;
                    padding-right: 0px;
                }
                span i {
                    padding-right: 10px;
                }
            }
            
            .nav-item {
                position: relative;
                text-align: left;
                .icon-right {
                    // padding-left: 35px;
                    font-weight: bold;
                    float: right;
                    margin-right: 12px;
                }
                ul {
                    background: rgba(0, 0, 0, 0.1);
                }
                .nav-open-sub {
                    display: block;
                // padding-left: 25px;
                    li {
                        padding-left: 25px;
                    }
                    a {
                        text-align: left;
                    }
                }
                .nav-close-sub {
                    display: none;
                }
                & > a:before {
                    content: "";
                    position: absolute;
                    left: 0px;
                    width: 2px;
                    height: 46px;
                    background: #34a0ce;
                    opacity: 0;
                    transition: all 0.3s;
                }

                & > a:hover {
                    color: #fff;
                    background: rgba(0, 0, 0, 0.1);
                }
                & > a:hover:before {
                    opacity: 1;
                }
                li:hover a {
                    color: #fff;
                    background: rgba(0, 0, 0, 0.1);
                }
            }

        }
        .nav-mini {
            width: 0px;
            left: -160px;
            overflow: hidden;
        }
    }
}
</style>
